// extracted by mini-css-extract-plugin
export default {"container":"Details_container__IEZzk","content":"Details_content__btU-X","avatar":"Details_avatar__h3UkM"};